import { postCore as post } from "../../utils/httpInterceptor";

class UserPasswordService {
  static changePassword(currentPassword, newPassword, confirmPassword) {
    return post("/api/me/password", {
      currentPassword,
      newPassword,
      confirmPassword,
    });
  }
}

export default UserPasswordService;
